var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticStyle:{"width":"100%","height":"88px"}},[_c('div',{staticClass:"header"},[_c('i',{on:{"click":function($event){return _vm.back()}}}),(!_vm.pageTitle)?_c('div',{staticClass:"gamerLogo"}):_vm._e(),(_vm.pageTitle)?_c('div',{staticClass:"textTitle"},[_vm._v(_vm._s(_vm.pageTitle))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }